import { render, staticRenderFns } from "./VideoUpload.vue?vue&type=template&id=2ba8a404&scoped=true&"
import script from "./VideoUpload.vue?vue&type=script&lang=js&"
export * from "./VideoUpload.vue?vue&type=script&lang=js&"
import style0 from "./VideoUpload.vue?vue&type=style&index=0&id=2ba8a404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba8a404",
  null
  
)

export default component.exports